import React, { useRef, useEffect } from 'react';
import { Popover } from 'react-bootstrap';
import CalendarWidget from './CalendarWidget';
import { IoClose } from 'react-icons/io5'; // Import close icon from react-icons

const ReviewCalendarPopover = ({
  startDate,
  endDate,
  onSelectDays,
  onClose,
  selectedSubtask,
  initialPlannedDates,
}) => {
  const popoverRef = useRef(null);

  // Handle click outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  return (
    <Popover
      id="custom-calendar-popover"
      className="custom-popover left"
      ref={popoverRef}
    >
      <div className="relative">
        {/* Close icon */}
        <button
          onClick={onClose}
          className="absolute top-2 right-2 p-1 rounded-full hover:bg-gray-100
                     text-gray-500 hover:text-gray-700 transition-colors duration-200"
          aria-label="Close calendar"
        >
          <IoClose size={20} />
        </button>

        <Popover.Body>
          <CalendarWidget
            startDate={startDate}
            endDate={endDate}
            onSelectDays={(days) => {
              console.log('Days selected in popover:', days);
              onSelectDays(days);
            }}
            initialPlannedDates={initialPlannedDates}
            selectedSubtask={selectedSubtask}
            initialCompletedDates={selectedSubtask?.completedDays || []} // A
          />
          {/* Done button */}
        </Popover.Body>
      </div>
    </Popover>
  );
};

export default ReviewCalendarPopover;
